var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Checkbox, DateTimeInput, HTMLInput, Input, Select, TextArea, } from ".";
import { useTranslation } from "./hooks/useTranslation";
import { isEmail, isInteger, isNumber, isURL } from "./utils/validators";
import { DEFAULT_ID } from "./withFormWrapper";
var all = function (builtInValidator, customValidator) {
    return function (v) {
        if (builtInValidator) {
            var result = builtInValidator(v);
            if (typeof result === "string") {
                return result;
            }
        }
        if (customValidator) {
            return customValidator(v);
        }
        return true;
    };
};
export var CustomFieldInput = function (_a) {
    var label = _a.label, name = _a.name, type = _a.type, _b = _a.options, options = _b === void 0 ? [] : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, customValidator = _a.valid, _d = _a.required, required = _d === void 0 ? false : _d, onChange = _a.onChange, _e = _a.uniqueId, uniqueId = _e === void 0 ? DEFAULT_ID : _e, additionalInputProps = _a.additionalInputProps, dataId = _a.dataId, dataTestId = _a.dataTestId;
    var t = useTranslation();
    var isBlankOrEmail = function (v) {
        return !v || isEmail(v) || t("Value must be a valid email");
    };
    var isBlankOrUrl = function (v) {
        return !v || isURL(v) || t("Value must be a valid URL");
    };
    var isBlankOrNumber = function (v) {
        return !v || isNumber(v) || t("Value must be a number");
    };
    var isBlankOrInteger = function (v) {
        return !v || isInteger(v) || t("Value must be an integer");
    };
    var commonProps = {
        label: label,
        name: name,
        disabled: disabled,
        required: required,
        uniqueId: uniqueId,
        dataId: dataId,
        dataTestId: dataTestId,
        onChange: onChange,
    };
    switch (type) {
        case "string":
            return React.createElement(Input, __assign({}, commonProps, { valid: customValidator }));
        case "url":
            return (React.createElement(Input, __assign({}, commonProps, { valid: function (v) { return all(isBlankOrUrl, customValidator)(v); } })));
        case "email":
            return (React.createElement(Input, __assign({}, commonProps, { valid: function (v) { return all(isBlankOrEmail, customValidator)(v); } })));
        case "text":
            return React.createElement(TextArea, __assign({}, commonProps, { valid: customValidator }));
        case "html":
            return React.createElement(HTMLInput, __assign({}, commonProps, { valid: customValidator }));
        case "number":
            return (React.createElement(Input, __assign({}, commonProps, { valid: function (v) { return all(isBlankOrNumber, customValidator)(v); } })));
        case "integer":
            return (React.createElement(Input, __assign({}, commonProps, { valid: function (v) { return all(isBlankOrInteger, customValidator)(v); } })));
        case "checkbox":
            return (React.createElement(Checkbox, { name: name, disabled: disabled, required: required, uniqueId: uniqueId, dataId: dataId, dataTestId: dataTestId, onChange: onChange, description: label, valid: customValidator }));
        case "choice":
        case "country":
        case "language":
        case "location":
            return (React.createElement(Select, __assign({}, commonProps, { options: options ? options : [], valid: customValidator })));
        case "locations":
        case "multichoice":
            return (React.createElement(Select, __assign({ multiple: true }, commonProps, { options: options ? options : [], valid: customValidator })));
        case "date":
        case "time":
        case "datetime":
            return (React.createElement(DateTimeInput, __assign({}, commonProps, { type: type, valid: customValidator }, (additionalInputProps || {}))));
        case "document":
            // Document type not yet supported as we don't have the necessary document picker yet
            return null;
        default:
            return null;
    }
};
